import { useEffect } from "react";

const SITE_URL = "https://emergentfood.com";
const DEFAULT_OG_IMAGE =
  "https://images.unsplash.com/photo-1651525670114-2b8117390b28?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85";

function upsertMeta({ name, property, content }) {
  const sel = name ? `meta[name="${name}"]` : `meta[property="${property}"]`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("meta");
    if (name) el.setAttribute("name", name);
    if (property) el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertJsonLd(id, obj) {
  let el = document.head.querySelector(`script[data-jsonld="${id}"]`);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-jsonld", id);
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(obj);
}

export default function useSeo({
  title,
  description,
  path = "/",
  image = DEFAULT_OG_IMAGE,
  lang = "it",
  jsonLd = [],
} = {}) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) upsertMeta({ name: "description", content: description });

    const url = `${SITE_URL}${path}`;
    upsertLink("canonical", url);

    upsertMeta({ property: "og:type", content: "website" });
    upsertMeta({ property: "og:site_name", content: "Emergent Food" });
    upsertMeta({ property: "og:title", content: title || "Emergent Food" });
    upsertMeta({ property: "og:description", content: description || "" });
    upsertMeta({ property: "og:url", content: url });
    upsertMeta({ property: "og:image", content: image });
    upsertMeta({ property: "og:locale", content: lang === "en" ? "en_GB" : "it_IT" });

    upsertMeta({ name: "twitter:card", content: "summary_large_image" });
    upsertMeta({ name: "twitter:title", content: title || "Emergent Food" });
    upsertMeta({ name: "twitter:description", content: description || "" });
    upsertMeta({ name: "twitter:image", content: image });

    upsertMeta({ name: "theme-color", content: "#050505" });
    document.documentElement.lang = lang;

    // JSON-LD blocks — remove any stale blocks from previous route first
    document.head
      .querySelectorAll('script[data-jsonld]')
      .forEach((el) => el.remove());
    const blocks = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
    blocks.forEach((b, i) => {
      if (b) upsertJsonLd(`${path}-${i}`, b);
    });
  }, [title, description, path, image, lang, JSON.stringify(jsonLd)]);
}

export const SEO_SITE_URL = SITE_URL;
